import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { Card, CardContent, Grid, TextField } from "@mui/material";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../../App/State/Slices/SelectedCareersClientSlice";
import Breadcrumb from "../../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import { Redirect, useLocation } from "react-router-dom";
import { JobGroups } from "../../../App/Enums/JobGroups";

function ReportUser() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "80%",
      marginBottom: "50px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    cardContainer: {
      [theme.breakpoints.down("md")]: {
        width: "100%",
        overflowY: "scroll",
      },
      display: "flex",
      flexDirection: "column",
      marginBottom: "20px",
      width: "100%",
    },
    error: {
      color: theme.palette.error.main,
    },
  }));

  const classes = useStyles();
  let location = useLocation();
  const selectCareersClient = useSelector(selectCareersClientValue);
  const [clientId, setClientId] = useState("");

  const [categories, setCategories] = useState("");
  const [families, setFamilies] = useState("");
  const [industries, setIndustries] = useState("");

  useEffect(() => {
    if (location.state !== null) {
      setClientId(location.state.clientId);

      var tempCategories = "";
      var tempFamilies = "";
      var tempIndustries = "";

      var arr = location.state?.talentNetworkUserDataGroupXrefs;

      for (var x in arr) {
        if (arr[x]?.group?.typeId === JobGroups.Industry) {
          tempIndustries += arr[x]?.group?.name + ",";
        }
        if (arr[x]?.group?.typeId === JobGroups.Family) {
          tempFamilies += arr[x]?.group?.name + ",";
        }
        if (arr[x]?.group?.typeId === JobGroups.Category) {
          tempCategories += arr[x]?.group?.name + ",";
        }
      }

      setCategories(tempCategories);
      setFamilies(tempFamilies);
      setIndustries(tempIndustries);
    }
  }, []);

  if (location.state === null) {
    return <Redirect to="/marketreport" />;
  }

  if (selectCareersClient.id !== clientId && clientId !== "") {
    return <Redirect to="/marketreport" />;
  }

  return (
    <>
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">
          {selectCareersClient.shortName} User Report
        </h1>
        <div className={classes.root}>
          <span>
            {location.state?.fullName +
              " - " +
              location.state?.phoneNumber +
              " - " +
              location.state?.email}
          </span>
          <Grid className={classes.cardContainer}>
            <Card className={classes.card}>
              <CardContent>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      placeholder="Zip Code"
                      label="Zip Code"
                      variant="standard"
                      fullWidth
                      value={location.state?.zip}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      placeholder="City"
                      label="City"
                      variant="standard"
                      fullWidth
                      value={location.state?.city}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      placeholder="State"
                      label="State"
                      variant="standard"
                      fullWidth
                      value={location.state?.state}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      placeholder="Country"
                      label="Country"
                      variant="standard"
                      fullWidth
                      value={location.state?.country}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      placeholder="Current Position"
                      label="Current Position"
                      variant="standard"
                      fullWidth
                      value={location.state?.currentPosition}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <TextField
                      placeholder="Certificatons"
                      label="Certificatons"
                      variant="standard"
                      fullWidth
                      value={location.state?.certifications}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      placeholder="Custom Data 1"
                      label="Custom Data 1"
                      variant="standard"
                      fullWidth
                      value={location.state?.other1}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      placeholder="Custom Data 2"
                      label="Custom Data 2"
                      variant="standard"
                      fullWidth
                      value={location.state?.other2}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      placeholder="Custom Data 3"
                      label="Custom Data 3"
                      variant="standard"
                      fullWidth
                      value={location.state?.other3}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <TextField
                      placeholder="Internal"
                      label="Internal"
                      variant="standard"
                      fullWidth
                      value={location.state?.isInternal ? "Yes" : "No"}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      placeholder="Level of Interest"
                      label="Level of Interest"
                      variant="standard"
                      fullWidth
                      value={location.state?.interestLevel}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <TextField
                      placeholder="Signup Date"
                      label="Signup Date"
                      variant="standard"
                      fullWidth
                      value={location.state?.dateCreated}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <TextField
                      placeholder="Last Updated Date"
                      label="Last Updated Date"
                      variant="standard"
                      fullWidth
                      value={location.state?.dateUpdated}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      placeholder="Categories"
                      label="Categories"
                      variant="standard"
                      fullWidth
                      value={categories}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      placeholder="Families"
                      label="Families"
                      variant="standard"
                      fullWidth
                      value={families}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      placeholder="Industries"
                      label="Industries"
                      variant="standard"
                      fullWidth
                      value={industries}
                      disabled
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </div>
      </div>
    </>
  );
}

export default ReportUser;
